import React from 'react';
import CustomSpinner from '../CustomSpinner';
import { StyledBox } from './styled';

const LoadingSpinner = () => {
  return (
    <StyledBox>
      <CustomSpinner size={48} disableShrink />
    </StyledBox>
  );
};

export default LoadingSpinner;
